import React, { Fragment } from 'react';
import { Form, Select } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';

const DriveUnitTypes = ({ form, disabled, driveUnitTypes, defaultValue }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Тип привода:</span>
      <Form.Item>
        {getFieldDecorator('driveUnitType')(
          <Select
            placeholder="Выберите тип привода"
            className="basicInput"
            disabled={disabled}
            getPopupContainer={trigger => trigger.parentNode}
          >
            {driveUnitTypes &&
              driveUnitTypes.map((item, index) => (
                <Select.Option value={item.vehicleDriveUnitTypeId} key={index}>
                  {item.driveUnitTypeName}
                </Select.Option>
              ))}
          </Select>
        )}
      </Form.Item>
    </Fragment>
  );
};

export default transportFieldsConnect(DriveUnitTypes, ['driveUnitTypes']);
